import type {State} from '../../../reducers/types'

import type {CompareBuildsLine, CompareBuildsInfoGroup} from './CompareBuildsPage.types'

export const getShowChangedOnly: (arg0: State) => boolean = state =>
  state.compareBuilds.settings.showChangedOnly

export const processGroups: (
  arg0: ReadonlyArray<CompareBuildsInfoGroup>,
  arg1: number,
) => ReadonlyArray<CompareBuildsLine> = (groups, level) =>
  groups.reduce((acc: Array<CompareBuildsLine>, group: CompareBuildsInfoGroup) => {
    if (group.name != null && group.name.length > 0) {
      if (groups.length > 1 || level > 0 || (group.groups != null && group.groups.length > 0)) {
        acc.push({
          type: 'title',
          name: group.name,
          hasChildren:
            (group.groups != null && group.groups.length > 0) ||
            (group.rows != null && group.rows.length > 0),
          level,
        })
      }
    }

    if (group.groups != null && group.groups.length > 0) {
      acc.push(...processGroups(group.groups, level + 1))
    }

    if (group.rows != null && group.rows.length > 0) {
      acc.push(...group.rows)
    }

    return acc
  }, [])
